import { makeStyles, Typography } from '@material-ui/core';
import React from 'react';

import { useTranslation } from 'react-i18next';
import { fonts } from 'theme';
import DocumentList from './DocumentList';

const useStyles = makeStyles({
  title: {
    margin: '0',
    fontFamily: fonts.titles,
  },
});

const DocumentListPage: React.FC = () => {
  const { t } = useTranslation();
  const classes = useStyles();
  return (
    <>
      <Typography variant="h1" className={classes.title}>
        {t('resources.title')}
      </Typography>
      <DocumentList />
    </>
  );
};
export default DocumentListPage;
